<template>
  <div class="pay-invoice__wrapper">
    <div v-if="isLoading" class="loading-indicator"><MoonLoader size="75px" color="#ffffff"></MoonLoader></div>
    <div class="css-grid pay-invoice__header">
      <div class="pay-invoice__header-name">Pay Fuel Invoice</div>
    </div>
    <OutOfOrderView v-if="showOutOfOrderView"></OutOfOrderView>
    <PaymentView v-if="showPaymentView"></PaymentView>
    <ErrorMessageView v-if="showErrorView"></ErrorMessageView>
    <SuccessMessageView v-if="showSuccessView"></SuccessMessageView>
    <UnknownMessageView v-if="showUnknownView"></UnknownMessageView>

    <div class="pay-invoice__footer"></div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { MoonLoader } from 'vue-spinner/dist/vue-spinner.min.js';
  import PaymentView from '../pay-invoice/PaymentView.vue';
  import OutOfOrderView from '../pay-invoice/OutOfOrderView.vue';
  import UnknownMessageView from '../pay-invoice/UnknownMessageView.vue';
  import ErrorMessageView from '../pay-invoice/ErrorMessageView.vue';
  import SuccessMessageView from '../pay-invoice/SuccessMessageView.vue';

  export default {
    name: 'PayInvoiceLayout',
    components: {
      MoonLoader,
      PaymentView,
      ErrorMessageView,
      OutOfOrderView,
      SuccessMessageView,
      UnknownMessageView,
    },
    computed: {
      ...mapGetters('payInvoice', ['currentSection', 'loaders']),
      showOutOfOrderView() {
        return this.currentSection === 'outOfOrder';
      },
      showPaymentView() {
        return this.currentSection === 'billingInfo';
      },
      showErrorView() {
        return this.currentSection === 'errorMessage';
      },
      showSuccessView() {
        return this.currentSection === 'successMessage';
      },
      showUnknownView() {
        return this.currentSection === 'unknownMessage';
      },
      isLoading() {
        return this.loaders.submitting;
      }
    },
    mounted() {
      this.$store.dispatch('main/setProperty', { key: 'globalLoading', value: false });
    },
    beforeRouteLeave(to, from, next) {
      this.$store.dispatch('payInvoice/resetForm');
      next();
    },
  };
</script>
